import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../seo/seo.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-condomini',
  imports: [CommonModule],
  templateUrl: './condomini.html',
  styleUrls: ['./condomini.scss'],
})
export class CondominiComponent implements OnInit {
  constructor(private seo: SeoService, private router: Router) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia condomini a Pescara | SAMI Pulizie',
      description:
        'Pulizie professionali per condomini a Pescara: scale, pianerottoli, ascensori, vetri e spazi comuni. Sopralluogo e preventivo gratuito.',
      keywords:
        'pulizia condomini Pescara, pulizie scale, pulizia ascensori, impresa pulizie Pescara, SAMI Pulizie',
      canonicalUrl: '/condomini',

      ogTitle: 'Pulizia condomini a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizi professionali per scale, pianerottoli, ascensori e aree comuni condominiali. Sopralluogo gratuito.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia condomini a Pescara | SAMI Pulizie',
      twitterDescription:
        'Pulizie professionali per condomini a Pescara. Sopralluogo e preventivo gratuito.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia condomini',
        description:
          'Servizi professionali di pulizia per scale, ascensori, pianerottoli e spazi comuni condominiali.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: {
          '@type': 'AdministrativeArea',
          name: 'Pescara',
        },
        url: 'https://samipulizie.it/condomini',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
